import { filterDynamicAnswers as excludeDynamicAnswers } from '../../../labelling/reducers/utils/utils';
import type { AnnotationT } from '../../../labelling/types/annotations.type';
import type { AnnotationWritePayload, FramePayload, MetadataPayload, SpanT } from '../types';
export function toFramePayload(annotation: AnnotationT): FramePayload {
  return {
    geometry: annotation.data,
    isKeyFrame: annotation.keyFrame?.isKeyFrame ?? false,
    keyFrameType: annotation.keyFrame?.type,
    keyFrameSource: annotation.keyFrame?.source,
    mlState: annotation.metadata?.mlData?.state
  };
}
export function toAnnotationWritePayload(annotation: AnnotationT): AnnotationWritePayload {
  return {
    ...toFramePayload(annotation),
    labelId: annotation.annotationLabel.title,
    annotationType: annotation.annotationType,
    originalId: annotation.metadata?.originalId,
    annotationSource: annotation.metadata?.annotationSource
  };
}
export function toMetadataPayload(annotationId: string, annotation: AnnotationT, initialSpan: SpanT): MetadataPayload {
  return {
    annotationId,
    labelId: annotation.annotationLabel.title,
    annotationType: annotation.annotationType,
    spans: [initialSpan],
    keyframes: annotation.keyFrame?.isKeyFrame ? [{
      frameIndex: initialSpan.start,
      type: annotation.keyFrame.type ?? 'MANUAL'
    }] : [],
    answers: excludeDynamicAnswers(annotation.metadata?.answers),
    originalId: annotation.metadata?.originalId,
    annotationSource: annotation.metadata?.annotationSource,
    consensusInfo: annotation.metadata?.consensusInfo
  };
}